import { render, staticRenderFns } from "./ImgViewer.vue?vue&type=template&id=ca6a808a"
import script from "./ImgViewer.vue?vue&type=script&lang=ts"
export * from "./ImgViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports